import * as React from 'react';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { getFeaturedCatalogs } from '@/redux/modules/featuredCatalogs';
import { useAppSelector } from '@/redux/hooks';
import CatalogGrid from '@/components/CatalogCard/CatalogGrid';
import CompleteAccountBanner from '@/components/CompleteAccountBanner/CompleteAccountBanner';
import PageTitle from '@/components/PageTitle/PageTitle';
import styled from 'styled-components';

const FeaturedCatalogsPage = () => {
    const catalogIds = useAppSelector(getFeaturedCatalogs);
    return (
        <StyledPageContainer>
            <CompleteAccountBanner />
            <PageTitle title={<FormattedMessage id="featured_auctions" />} />
            <StyleCatalogGrid catalogIds={catalogIds} />
        </StyledPageContainer>
    );
};

export default FeaturedCatalogsPage;

const StyledPageContainer = styled.div`
    width: 100%;
    margin: 0 auto;
    padding: 0 20px 30px;
    max-width: ${({ theme }) => theme.breakpoints.pageWidth};
`;

const StyleCatalogGrid = styled(CatalogGrid)`
    margin: 0 -10px;
`;
